/**
 * @module cercaliagl/view/VShadowBuildings
 */
import $ from 'jquery';
import { MDCSlider } from '@material/slider';
import { MDCSwitch } from '@material/switch';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
import { createSlider, createSwitch, formatDate } from './VUtils';

/**
 * @typedef {Object} ShadowBuildingsOptions
 * @property {string} date Date YYYY-MM-DD
 * @property {number} seconds Seconds from midnight
 */

/**
 * @enum {string}
 */
export const EventType = {
  ENABLE: 'enable',
  DISABLE: 'disable',
  CHANGE: 'change',
};

/**
 * @classdesc
 */
class VShadowBuildings extends BaseView {
  /**
   * @constructor
   */
  constructor() {
    const date = new Date();
    const currentVal = (date.getHours() * 2) + (date.getMinutes() < 30 ? 0 : 1);
    const jqElement = $(`
      <div class="v-shadow-buildings mdc-elevation--z4">
        <div class="header">
          <div class="title">${i18n('sunLight')}</div>
          ${createSwitch('switch')}
        </div>
        <div class="inputs">
          <div class="date-input">
            <input type="date" name="date" value="${formatDate(new Date())}">
          </div>
          <div class="slider-input">
            <i class="icon icon-time"></i>
            <div class="box">
              ${createSlider('timeslider', 0, 47, currentVal, false, ' ')}
            </div>
          </div>
        </div>
      </div>
    `);

    super(jqElement);

    /**
     * @private
     * @type {MDCSlider}
     */
    this.mdcTimeSlider_ = null;

    /**
     * @private
     * @type {JQuery}
     */
    this.jqInputDate_ = null;

    this.initialize_();
  }

  /**
   * Necessary after create and after show/hide
   * @private
   */
  refreshSlidersLayout_() {
    this.mdcTimeSlider_.layout();
  }

  /**
   * @override
   * @param {boolean} [animation]
   */
  show() {
    this.jqElement_.show();
    this.refreshSlidersLayout_();
  }

  /**
   * @private
   */
  initialize_() {
    if (!this.jqElement_) {
      return;
    }
    const jqMdcSwitch = this.jqElement_.find('.mdc-switch');
    const jqMdcSlider = this.jqElement_.find('.mdc-slider.timeslider');

    if (!jqMdcSwitch || jqMdcSwitch.length === 0 || !jqMdcSlider || jqMdcSlider.length === 0) {
      return;
    }
    this.switchEnable_ = new MDCSwitch(jqMdcSwitch.get(0));
    this.switchEnable_.listen('click', this.handleSwitchChange_.bind(this));

    this.mdcTimeSlider_ = new MDCSlider(jqMdcSlider.get(0));
    this.mdcTimeSlider_.listen('MDCSlider:change', this.handleChangeTime_.bind(this));
    this.mdcTimeSlider_.listen('MDCSlider:input', this.handleChangeTime_.bind(this));

    this.jqInputDate_ = this.jqElement_.find('input[name="date"]');
    this.jqInputDate_.on('change', this.handleChangeTime_.bind(this));

    this.jqElement_.find('.value').text('hourMins');
    this.handleChangeTime_(false);
  }

  handleSwitchChange_() {
    const jqInputDiv = this.jqElement_.find('.inputs');
    if (this.switchEnable_.selected) {
      this.emit(EventType.ENABLE);
      jqInputDiv.css('display', 'table');
      this.refreshSlidersLayout_();
    } else {
      this.emit(EventType.DISABLE);
      jqInputDiv.hide();
    }
  }

  /**
   * @private
   * @param {boolean} [fireEvent]  Fire event
   */
  handleChangeTime_(fireEvent = true) {
    const val = this.mdcTimeSlider_.getValue();
    const hour = Math.floor(val / 2);
    const minutes = val % 2 === 0 ? '00' : '30';
    const hourMins = `${hour}:${minutes}`;
    this.jqElement_.find('.value').text(hourMins);

    const date = this.jqInputDate_.val();
    if (fireEvent) {
      this.emit(EventType.CHANGE, { date, hourmins: hourMins });
    }
  }

  /**
   * @param {boolean} enable enable
   */
  toggle(enable) {
    this.switchEnable_.selected = enable;
    this.handleSwitchChange_();
  }
}

export default VShadowBuildings;
